export class Category {
  constructor() {}
  categoryId: any = '';
  name: any = '';
}
